import { render } from "./SkychartDatapointsSwitches.vue?vue&type=template&id=28065dda"
import script from "./SkychartDatapointsSwitches.vue?vue&type=script&lang=js"
export * from "./SkychartDatapointsSwitches.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__